import React, { Component } from 'react';
import './bottom.css';
//import IconApp from './icon-app.js';
import AppIcon from './AppIcon';


import iconPhone from '../images/icons/1492509249_phone_ios7_ios_7.png';
import iconCamera from '../images/icons/1492509273_camera_ios7_ios_7.png';
import iconMusic from '../images/icons/1492509278_music_ios7_ios_7.png';
import iconPhotos from '../images/icons/1492509282_photos_ios7_ios_7.png';


const Bottom = ({isChildOpen}) => {
  // state = {
  //     isChildOpen: false
  // };

  // shouldComponentUpdate(nextProps, nextState) {
  //   return false;
  // }

  // isChildOpen(isChildOpen, childHandle) {
  //   //console.log('isChildOpen() page ' + this.props.pagenumber + ' ');
  //   this.setState({
  //     isChildOpen,
  //     childHandle
  //   });
  // };

  return (
    <div className="bottom" data-isopen={isChildOpen}>
      <div className="bottom-grid" style={{position: 'relative', margin: '10px', marginTop: '0px'}}>
        <AppIcon
            appName="Phone"
            item={1}
            pagenumber={-1}
            icon={iconPhone}
        />
        <AppIcon
            appName="Camera"
            item={2}
            pagenumber={-1}
            icon={iconCamera}
        />
        <AppIcon
            appName="Music"
            item={3}
            pagenumber={-1}
            icon={iconMusic}
        />
        <AppIcon
            appName="Photos"
            item={4}
            pagenumber={-1}
            icon={iconPhotos}
        />
          {/* <IconApp item={1} pagenumber={-1} />
          <IconApp item={2} pagenumber={-1} />
          <IconApp item={3} pagenumber={-1} />
          <IconApp item={4} pagenumber={-1} /> */}
      </div>
    </div>
  );
  
};

export default Bottom;
